/**
 * MA profile avatar display helpers.
 * Precedence mirrors SA getAvatarUrl / Account Profile (private-bucket safe):
 *   1. avatarUrl — short-lived presigned GET (canonical uploaded object)
 *   2. avatar when it is already an http(s) URL (Auth0/bootstrap picture)
 *   3. otherwise null → render initials (never use a raw S3 key as <img src>)
 */

import { resolveUserInitials } from "../auth/profileIdentity";

export function isHttpAvatarUrl(value) {
  return typeof value === "string" && /^https?:\/\//i.test(value.trim());
}

/**
 * @param {{ avatar?: string|null, avatarUrl?: string|null }} profile
 * @returns {string|null} browser-renderable URL or null
 */
export function resolveDisplayAvatarUrl(profile) {
  if (!profile || typeof profile !== "object") return null;
  const signed = profile.avatarUrl;
  if (typeof signed === "string" && signed.trim()) {
    return signed.trim();
  }
  const raw = profile.avatar;
  if (isHttpAvatarUrl(raw)) {
    return String(raw).trim();
  }
  return null;
}

/**
 * Persistable S3 key for PUT /me/profile (never a presigned URL).
 */
export function resolveAvatarStorageKey(profile) {
  if (!profile || typeof profile !== "object") return null;
  const raw = profile.avatar;
  if (raw == null || raw === "") return null;
  const value = String(raw).trim();
  if (!value || isHttpAvatarUrl(value)) return null;
  return value;
}

export function getProfileInitials({
  firstName = "",
  lastName = "",
  email = "",
} = {}) {
  return resolveUserInitials({ firstName, lastName, email });
}
